// extracted by mini-css-extract-plugin
module.exports = {"root":"_3_PmP","title":"_1d6Q5","panelWrapper":"_1-LNr","expandBtn":"_3lzVV","panelPreview":"_2eslE","panelFull":"gyTfV","showFade":"PbO7H","hideFade":"_1nO83"};